import { DEFAULT_UNDEFINED_STRING } from "../constants";

/**
 * @description Get tokens from pair symbol.
 * @returns [base, quote]
 */
export function getTokensFromPairSymbol(pairSymbol: string): [string, string] {
  if (!pairSymbol) return [DEFAULT_UNDEFINED_STRING, DEFAULT_UNDEFINED_STRING];
  const [base, quote] = pairSymbol.split("/");
  return [base || DEFAULT_UNDEFINED_STRING, quote || DEFAULT_UNDEFINED_STRING];
}
